import moment from 'moment';

import { ISODate } from './types';

const getMonth = (date?: ISODate): number => moment(date).month();

export default getMonth;
